import React, { useEffect, useRef, useState } from 'react';
import { cropFromRow, placeCover } from '../../utils/squadRows';

// A squad's cover photo shown with the crop its creator set, in whatever frame it is given.
export default function SquadCover({ squad, className = '', children }) {
  const frameRef = useRef(null);
  const [frame, setFrame] = useState({ w: 0, h: 0 });
  const [image, setImage] = useState({ w: 0, h: 0 });
  const uri = squad?.cover_url || '';

  useEffect(() => {
    const node = frameRef.current;
    if (!node) return undefined;
    const measure = () => setFrame({ w: node.offsetWidth, h: node.offsetHeight });
    measure();
    if (typeof ResizeObserver !== 'function') return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const box = uri ? placeCover(frame, image, cropFromRow(squad)) : null;
  return (
    <div ref={frameRef} className={`squad-cover ${className}`.trim()}>
      {uri ? (
        <img
          src={uri}
          alt=""
          onLoad={(event) => setImage({ w: event.target.naturalWidth, h: event.target.naturalHeight })}
          style={box ? { width: box.width, height: box.height, left: box.left, top: box.top, opacity: 1 } : { opacity: 0 }}
        />
      ) : null}
      {children}
    </div>
  );
}
